import React from 'react'

export default {
    'Transportation': {
        label: 'Transportation',
        searchParams: {
            holdIssueType: ['Envrnmntl', 'Green'],
            holdUseOfProceeds: ['Transportation'],
        },
        icon: <svg width="61" height="49" viewBox="0 0 61 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.8516 0.229004H9.85156C4.87156 0.229004 0.851562 4.249 0.851562 9.229V33.229C0.851562 38.209 4.87156 42.229 9.85156 42.229L6.85156 45.229V48.229H9.85156L15.8516 42.139L21.8516 42.229V27.229H6.85156V6.169L33.8516 6.229V12.229H39.8516V9.229C39.8516 4.249 35.8316 0.229004 30.8516 0.229004ZM9.85156 30.229C11.5016 30.229 12.8516 31.579 12.8516 33.229C12.8516 34.879 11.5016 36.229 9.85156 36.229C8.20156 36.229 6.85156 34.879 6.85156 33.229C6.85156 31.579 8.20156 30.229 9.85156 30.229ZM56.5616 17.209C56.1416 16.009 55.0016 15.229 53.6516 15.229H32.0816C30.7016 15.229 29.5916 16.009 29.1416 17.209L24.8516 29.539L24.8816 46.069C24.8816 47.209 25.8116 48.229 26.9516 48.229H28.8116C29.9516 48.229 30.8516 47.089 30.8516 45.949V42.229H54.8516V45.949C54.8516 47.089 55.7816 48.229 56.9216 48.229H58.7516C59.8916 48.229 60.8216 47.209 60.8216 46.069L60.8516 41.959V29.539L56.5616 17.209ZM32.0816 18.229H53.6516L56.7416 27.229H28.9916L32.0816 18.229ZM30.8516 36.229C29.2016 36.229 27.8516 34.879 27.8516 33.229C27.8516 31.579 29.2016 30.229 30.8516 30.229C32.5016 30.229 33.8516 31.579 33.8516 33.229C33.8516 34.879 32.5016 36.229 30.8516 36.229ZM54.8516 36.229C53.2016 36.229 51.8516 34.879 51.8516 33.229C51.8516 31.579 53.2016 30.229 54.8516 30.229C56.5016 30.229 57.8516 31.579 57.8516 33.229C57.8516 34.879 56.5016 36.229 54.8516 36.229Z" fill="#767676"/>
            </svg>
    },

    'Water': {
        label: 'Water & Power',
        searchParams: {
            holdIssueType: ['Envrnmntl', 'Green'],
            holdUseOfProceeds: ['Utilities'],
        },
        icon: <svg width="55" height="49" viewBox="0 0 55 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M54.5 30.229C54.5 28.429 53 27.229 51.5 27.229H45.5V33.229H51.5C53 33.229 54.5 32.029 54.5 30.229Z" fill="#767676"/>
        <path d="M51.5 39.229H45.5V45.229H51.5C53 45.229 54.5 43.729 54.5 42.229C54.5 40.729 53 39.229 51.5 39.229Z" fill="#767676"/>
        <path d="M27.5 30.229H21.5V42.229H27.5C27.5 45.529 30.2 48.229 33.5 48.229H42.5V24.229H33.5C30.2 24.229 27.5 26.929 27.5 30.229Z" fill="#767676"/>
        <path d="M6.5 27.229C6.5 23.929 9.2 21.229 12.5 21.229H17C22.7 21.229 27.5 16.429 27.5 10.729C27.5 5.029 22.7 0.229004 17 0.229004H6.5C4.7 0.229004 3.5 1.429 3.5 3.229C3.5 5.029 4.7 6.229 6.5 6.229H17C19.4 6.229 21.5 8.329 21.5 10.729C21.5 13.129 19.4 15.229 17 15.229H12.5C5.9 15.229 0.5 20.629 0.5 27.229C0.5 33.829 5.9 39.229 12.5 39.229H18.5V33.229H12.5C9.2 33.229 6.5 30.529 6.5 27.229Z" fill="#767676"/>
        </svg>
    },

    'Housing': {
        label: 'Housing & Government Buildings',
        searchParams: {
            holdIssueType: ['Envrnmntl', 'Green'],
            holdUseOfProceeds: ['Housing', 'Government'],
        },
        icon: <svg width="61" height="52" viewBox="0 0 61 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M51.8516 19.129V3.229H42.8516V11.029L30.8516 0.229004L0.851562 27.229H9.85156V51.229H24.8516V33.229H36.8516V51.229H51.8516V27.229H60.8516L51.8516 19.129ZM24.8516 21.229C24.8516 17.929 27.5516 15.229 30.8516 15.229C34.1516 15.229 36.8516 17.929 36.8516 21.229H24.8516Z" fill="#767676"/>
        </svg>
    },

    'Education': {
        label: 'Education & Healthcare',
        searchParams: {
            holdIssueType: ['Envrnmntl', 'Green'],
            holdUseOfProceeds: ['Education', 'Healthcare'],
        },
        icon: <svg width="67" height="55" viewBox="0 0 67 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.8516 30.769V42.769L33.8516 54.229L54.8516 42.769V30.769L33.8516 42.229L12.8516 30.769ZM33.8516 0.229004L0.851562 18.229L33.8516 36.229L60.8516 21.499V42.229H66.8516V18.229L33.8516 0.229004Z" fill="#767676"/>
        </svg>
    },

    'Pollution': {
        label: 'Pollution, Sanitation & Preservation',
        searchParams: {
            holdIssueType: ['Envrnmntl', 'Green'],
            holdUseOfProceeds: ['Industrial', 'Utilities'],
        },
        icon: <svg width="62" height="61" viewBox="0 0 62 61" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M61.3616 21.739C61.3616 10.129 51.9716 0.739014 40.3616 0.739014C28.7516 0.739014 19.3616 10.129 19.3616 21.739C19.3616 32.149 26.9216 40.759 36.8516 42.409V54.229H12.8516V45.229H15.8516V33.229C15.8516 31.579 14.5016 30.229 12.8516 30.229H3.85156C2.20156 30.229 0.851562 31.579 0.851562 33.229V45.229H3.85156V60.229H51.8516V54.229H42.8516V42.589C53.2616 41.359 61.3616 32.509 61.3616 21.739ZM8.35156 27.229C10.8416 27.229 12.8516 25.219 12.8516 22.729C12.8516 20.239 10.8416 18.229 8.35156 18.229C5.86156 18.229 3.85156 20.239 3.85156 22.729C3.85156 25.219 5.86156 27.229 8.35156 27.229Z" fill="#767676"/>
        </svg>
    },

}


// WEBPACK FOOTER //
// ./src/municipals/green-bonds/categories.js